import {
  CALL_US_INFO_ERROR,
  RECEIVED_CALL_US_INFO,
  REQUEST_CALL_US_INFO,
  RESET_CALL_US_INFO,
  STORE_CHATBOT_PARAMS,
} from './CallUs-Actions';

const initialState = {
  isLoading: false,
  isError: false,
  error: null,
  callUsInfo: {},
  chatParams: null,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CALL_US_INFO: {
      return { ...state, ...{ isLoading: true } };
    }
    case RECEIVED_CALL_US_INFO: {
      return {
        ...state,
        ...{
          isLoading: false,
          callUsInfo: action.payload.contactInfo,
        },
      };
    }
    case CALL_US_INFO_ERROR: {
      return {
        ...state,
        ...{
          isLoading: false,
          isError: true,
        },
      };
    }
    case STORE_CHATBOT_PARAMS:
      return {
        ...state,
        chatParams: action.payload,
      };
    case RESET_CALL_US_INFO:
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
